<template>
<BootstrapDialog title="单选题" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
			<div class="modal-body wrapper-lg" style="width:100%">
					<div class="tm_main" style="margin: 0px 0px;">
					    <div class="tm_container">
					        <table width="100%" cellpadding="5" border="0" class="tm_table_form">
					            <tbody>
					            <tr>
					                <th width="120" nowrap="nowrap">试题类别：</th>
					                <td width="40%" v-html="stlbName"></td>
					                <th width="120">题型名称：</th>
					                <td v-html="model.tx"></td>
					            </tr>
					            <tr v-if="model.tkmc">
					                <th width="120" nowrap="nowrap">所属题库：</th>
					                <td width="40%" v-html="model.tkmc"></td>
					                <th width="120">试题来源：</th>
					                <td v-html="model.stly"></td>
					            </tr>
					            <tr>
					                <th nowrap="nowrap">试题状态：</th>
					                <td v-html="model.zt=='OK'?'开放':'关闭'"></td>
					                <th nowrap="nowrap">试题难度：</th>
					                <td v-html="model.stnd=='FCRY'?'非常容易':
					                    model.stnd=='BJRY'?'比较容易':
					                    model.stnd=='CG'?'常规':
					                    model.stnd=='JN'?'较难':'非常难'"></td>
					
					            </tr>
					            <tr>
					                <th nowrap="nowrap">试题题干：</th>
					                <td colspan="3" v-html="model.sttg"></td>
					            </tr>
					            <tr id="suite">
					                <th nowrap="nowrap" id="tm_title">答案设置：
					                    <div style="margin-top: 12px;text-align: center;">
					                        <span v-html="model.stda"></span>
					                    </div>
					                </th>
					                <td colspan="3" id="tm_body">
					                    <table class="tm_question_options" align="left">
					                         <tbody v-for = "(option,index) in model.options" :key = "index">
					                                <tr>
					                                    <td width="80" style="text-align:center;">
					                                        <span v-html="option.alisa"></span>
					                                        &nbsp;
					                                        <input type="radio" disabled="disabled" :checked="option.alisa==model.stda">
					                                    </td>
					                                    <td v-html="option.text"></td>
					                                </tr>
					
					                        </tbody>
					                    </table>
					                </td>
					            </tr>
					            <tr>
					                <th nowrap="nowrap" >试题解析：</th>
					                <td colspan="3" id="">
					                    <div v-html="model.stjx"></div>
					                </td>
					            </tr>
					            </tbody>
					        </table>
					    </div>
					</div>
			</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>

    /**
     * 管理试题单选题
     */
    export default {
        name:'QuesDetailDanXt',
        components:{
		},
        data:function(){
            return {
                stlbList:[],
                stlb:'',
                stlbName:'',
                model:{
					id:'',
                    stlb:'',
                    tx:'',
                    tk_id:'',
                    stly:'',
                    zt:'',
                    stnd:'',
                    sttg:'',
                    stda:'',
                    options:[
                        {text:''}
                    ],
                    stjx:''
                },
            }
        },
        methods:{
			reset:function(){
				this.stlbList = [];
				this.stlb = '';
				this.stlbName = '';
				this.model = {
					id:'',
					stlb:'',
					tx:'',
					tk_id:'',
					stly:'',
					zt:'',
					stnd:'',
					sttg:'',
					stda:'',
					options:[
						{text:''}
					],
					stjx:''
				}
			},
			async open(params){
				this.stlb = params.stlb;
				this.model.id = params.id;
				if(this.model.id){
				   let res = await this.$http.post('/htgl/zktk/st/hq',{id:this.model.id});
				   this.model = res.data.zktkSt || {};
				   this.model.options = res.data.stxxnrJson.options;
				}
				this.stlbList = [{value: 'SINGLECHOICE', text: '单选题'}, {value: 'MULTIPLECHOICE', text: '多选题'}, {value: 'JUDGMENT', text: '判断题'}, {value: 'BLANKFILL', text: '填空题'}, {value: 'ESSAY', text: '问答题'}, {value: 'MCJST', text: '名词解释题'}, {value: 'LST', text: '论述题'}, {value: 'JDT', text: '简答题'}, {value: 'TT', text: '套题'}];//试题类别
				let list = this.stlbList.filter(x=>x.value == this.stlb);
				this.stlbName = list&&list.length>0 ?  list[0].text : '';
				this.$nextTick(()=>{
					this.$refs.dialog.open();
				})
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
        }
    }
</script>
<style scoped>
    .tm_main{
        margin: 10px 10px;
        width: 100%;
    }
    .tm_table_form tbody p {
        margin: 10px 10px;
    }
    .tm_table_form tbody tr th {
        text-align: right;
        font-size: 16px;
        border: solid 1px #eee;
        background: #f5f5f5;
        line-height: 20px;
        font-weight:800;
        padding: 12px;
    }
    .tm_table_form tr td {
        border: solid 1px #eee;
        padding: 12px;
        text-align: left;
        border: solid 1px #eee !important;
        background: #fff !important;
    }
    #tm_title div span{
        border: solid 1px green;
        padding: 5px;
    }
</style>